import { builderFetch } from '../../utilities';

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.runNow;

/**
 * Runs the recipe on demand
 *
 * @return {Promise} The apiFetch promise
 */
const runRecipe = () => {
	// Run the recipe
	return builderFetch( {
		endpoint: `run-now/start/${ UncannyAutomator._recipe.recipe_id }`,
		method: 'POST',
		snackbar: {
			loading: strings.starting,
			success: strings.started,
		}
	} );
}

export default runRecipe;
